import { render, staticRenderFns } from "./OrderFileRow.vue?vue&type=template&id=68998a6a&scoped=true"
import script from "./OrderFileRow.vue?vue&type=script&lang=js"
export * from "./OrderFileRow.vue?vue&type=script&lang=js"
import style0 from "./OrderFileRow.vue?vue&type=style&index=0&id=68998a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68998a6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
